import { render, staticRenderFns } from "./JbManPreventivaOsHistorico.vue?vue&type=template&id=2b7c2529&"
import script from "./JbManPreventivaOsHistorico.vue?vue&type=script&lang=js&"
export * from "./JbManPreventivaOsHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports